import { axiosClient, getToken } from '../../Config/axiosConfig';

export const getUnidadesBySearch = async (busqueda: string) => {
	await getToken();
	return await axiosClient.get(`/unidades?busqueda=${busqueda}`);
};
